import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { SOCIALS } from "../data/socials";

function Contact() {
  const formRef = useRef(null);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null); // "ok" | "err" | null

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setStatus(null);

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    if (!serviceId || !templateId || !publicKey) {
      console.warn("EmailJS env vars not configured");
      setStatus("err");
      setSending(false);
      return;
    }

    emailjs
      .sendForm(serviceId, templateId, formRef.current, publicKey)
      .then(() => {
        setStatus("ok");
        formRef.current.reset();
      })
      .catch(() => setStatus("err"))
      .finally(() => setSending(false));
  };

  return (
    <section className="section" id="contact">
      <div className="wrap">
        <span className="kicker reveal">Get in touch</span>
        <h2 className="contact-title reveal" data-d="1">
          Let's build
          <br />
          something <em>great.</em>
        </h2>
        <a href="mailto:iamabdulbasit5@gmail.com" className="contact-mail reveal" data-d="2">
          iamabdulbasit5@gmail.com
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M7 17L17 7M17 7H8M17 7V16" />
          </svg>
        </a>

        <div className="contact-layout reveal" data-d="3">
          <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
            <span className="form-label">Send a message</span>
            <div className="row">
              <div>
                <label htmlFor="user_name" className="sr-only">Name</label>
                <input
                  id="user_name"
                  className="field"
                  type="text"
                  name="user_name"
                  placeholder="Name"
                  required
                  aria-required="true"
                />
              </div>
              <div>
                <label htmlFor="user_email" className="sr-only">Email</label>
                <input
                  id="user_email"
                  className="field"
                  type="email"
                  name="user_email"
                  placeholder="Email"
                  required
                  aria-required="true"
                />
              </div>
            </div>
            <div>
              <label htmlFor="subject" className="sr-only">Subject</label>
              <input
                id="subject"
                className="field"
                type="text"
                name="subject"
                placeholder="Subject"
                required
                aria-required="true"
              />
            </div>
            <div>
              <label htmlFor="message" className="sr-only">Message</label>
              <textarea
                id="message"
                className="field"
                name="message"
                placeholder="Your message…"
                rows={5}
                required
                aria-required="true"
              />
            </div>
            <button type="submit" className="contact-submit" disabled={sending}>
              {sending ? "Sending…" : "Send message"}
            </button>
            <p className={`form-status${status ? ` ${status}` : ""}`} aria-live="polite">
              {status === "ok" && "Message sent — thanks, I'll be in touch."}
              {status === "err" && "Couldn't send. Email me directly at iamabdulbasit5@gmail.com."}
            </p>
          </form>

          <div className="contact-meta">
            <div className="cmeta-block">
              <h5>Location</h5>
              <p>
                Peshawar, KPK
                <br />
                Pakistan
              </p>
            </div>
            <div className="cmeta-block">
              <h5>Availability</h5>
              <p>
                Open to full-time roles,
                <br />
                freelance &amp; open source
              </p>
            </div>
            <div className="cmeta-block">
              <h5>Elsewhere</h5>
              <div className="socials">
                {SOCIALS.filter((s) => s.featured).map((s) => (
                  <a key={s.key} href={s.href} target="_blank" rel="noreferrer">
                    {s.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
